export const FETCH_POPULAR = 'FETCH_POPULAR'
export const FETCH_POPULAR_REQUEST = 'FETCH_POPULAR_REQUEST'
export const FETCH_POPULAR_SUCCESS = 'FETCH_POPULAR_SUCCESS'
